import vm from '@/main'

// Для русской локали шлём API-запросы на прямой домен core-ru
// (Cloudflare-прокси недоступен в РФ). Остальные локали — как раньше (core).
export default function (apiClient) {
  apiClient.interceptors.request.use(config => {
    if (vm.$i18n.locale === 'ru' && process.env.VUE_APP_API_BASE_URL_RU) {
      config.baseURL = process.env.VUE_APP_API_BASE_URL_RU
    }
    return config
  })
}
